import React, {Fragment} from 'react';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import CheckBox from './../../PageLayout/CheckBox';
import {store} from "../../../main";

const _dropZone = (parent, children) => {
    return (
    <Dropzone
        accept=".csv"
        onDrop={parent.onDrop}
        className="bulk-import-fileUpload"
        rejectStyle={{'boxShadow': '0 0 1em yellow inset'}}
        ref={parent.setDropzoneRef}
    >
        {children}
    </Dropzone>);
}

const _clearCheckbox = (parent) => {
    return (
    <Fragment>
        <CheckBox
            checked={parent.state.clearEmpty}
            innerStyle="none"
            colorClass="color-gray2"
            onChecked={(e) => parent.setState({clearEmpty: !parent.state.clearEmpty})}
            text="Clear Empty Features"
        />
        {parent.state.clearEmpty ? (
            <div className="bulk-import-clearWarning">
                <span>Warning:</span>
                Selecting this option will erase all features that appear empty in the uploaded spreadsheet.
            </div>
        ) : null}
    </Fragment>);
}

const _assignRelatedBoxes = (parent) => {
    return (
    <Fragment>
        {/* <CheckBox
            checked={parent.state.assignRelatedBoxes}
            innerStyle="none"
            colorClass="color-gray2"
            onChecked={(e) => parent.setState({assignRelatedBoxes: !parent.state.assignRelatedBoxes})}
            text="Assign Related Boxes"
        /> */}
        {parent.state.assignRelatedBoxes ? (
            <div className="bulk-import-clearWarning">
                <span>Warning:</span>
                Selecting this option will erase all related features of <b>Top Cabinets</b> and <b>Bottom Cabintes</b>. 
                Then it will assign every <b>Upper Cabinet Boxes</b> to <b>Top Cabinets</b> and every <b>Lower Cabinet Boxes</b> to <b>Bottom Cabinets</b>.
            </div>
        ) : null}
    </Fragment>);
}

const _createCopies = (parent) => {
    return (
    <Fragment>
        <CheckBox
            checked={parent.state.createCopies}
            innerStyle="none"
            colorClass="color-gray2"
            onChecked={(e) => parent.setState({createCopies: !parent.state.createCopies})}
            text="Import copy mode"
        />
        {parent.state.createCopies ? (
            <div className="bulk-import-clearWarning">
                <span>Warning:</span>
                Selecting this mode, the CSV import will <b>create copies</b> of the features you're importing with adding 'Copy X', where X is a number, to their Display Names. 
            </div>
        ) : null}
    </Fragment>);
}


export const CategoriesOnlyCheckbox = ({parent}) => {
    return (<Fragment>
        <CheckBox
        checked={parent.state.backupCategoriesOnly}
        innerStyle="none"
        colorClass="color-gray2"
        onChecked={(e) => parent.setState({backupCategoriesOnly: !parent.state.backupCategoriesOnly})}
        text="Backup features within Feature Group Categories only"
        />
        <CheckBox
        checked={parent.state.backupWizardOnly}
        innerStyle="none"
        colorClass="color-gray2"
        onChecked={(e) => parent.setState({backupWizardOnly: !parent.state.backupWizardOnly})}
        text="Backup features within Wizards only"
        />
    </Fragment>);
}

export const KitchenOrBathroomCheckboxes = ({parent}) => {
    return (
        <Fragment>
            <CheckBox
                checked={parent.state.backupKitchen}
                innerStyle="none"
                colorClass="color-gray2"
                onChecked={(e) => parent.setState({backupKitchen: !parent.state.backupKitchen, backupEnabled: !parent.state.backupKitchen || parent.state.backupBathroom || parent.state.backupFireplace || parent.state.backupLaundryroom})}
                text="Backup features enabled for the Kitchen"
            />
            <CheckBox
                checked={parent.state.backupBathroom}
                innerStyle="none"
                colorClass="color-gray2"
                onChecked={(e) => parent.setState({backupBathroom: !parent.state.backupBathroom, backupEnabled: parent.state.backupKitchen || !parent.state.backupBathroom || parent.state.backupFireplace || parent.state.backupLaundryroom})}
                text="Backup features enabled for the Bathroom"
            />
            <CheckBox
                checked={parent.state.backupFireplace}
                innerStyle="none"
                colorClass="color-gray2"
                onChecked={(e) => parent.setState({backupFireplace: !parent.state.backupFireplace, backupEnabled: parent.state.backupKitchen || parent.state.backupBathroom || !parent.state.backupFireplace || parent.state.backupLaundryroom})}
                text="Backup features enabled for the Fireplace"
            />
            <CheckBox
                checked={parent.state.backupLaundryroom}
                innerStyle="none"
                colorClass="color-gray2"
                onChecked={(e) => parent.setState({backupLaundryroom: !parent.state.backupLaundryroom, backupEnabled: parent.state.backupKitchen || parent.state.backupBathroom || !parent.state.backupFireplace || parent.state.backupLaundryroom})}
                text="Backup features enabled for the Laundryroom"
            />

            <CheckBox
                checked={parent.state.backupFilters}
                innerStyle="none"
                colorClass="color-gray2"
                onChecked={(e) => parent.setState({backupFilters: !parent.state.backupFilters})}
                text="Backup Filters of Features"
            />
        </Fragment>
    );
}

export const ToolSettingsTypeCheckboxes = ({parent}) => {
    return (
        <Fragment>
            <CheckBox
                checked={parent.state.visualizerOnly}
                innerStyle="none"
                colorClass="color-gray2"
                onChecked={(e) => parent.setState({visualizerOnly: !parent.state.visualizerOnly})}
                text="Visualizer only"
            />
            <CheckBox
                checked={parent.state.quotingToolOnly}
                innerStyle="none"
                colorClass="color-gray2"
                onChecked={(e) => parent.setState({quotingToolOnly: !parent.state.quotingToolOnly})}
                text="Quoting Tool only"
            />
        </Fragment>
    );
}

export const FeatureRecordDownload = ({hasRecords, showWarning, onClick}) => {
    return (
      <div>
        {hasRecords || true ? (
            showWarning ? (
                <div className="bulk-import-text--red">
                    <div className="bulk-import-link--red">Feature Backup Required</div>
                    A backup of your current features will automatically be downloaded
                </div>
            ) : (
                <div className="bulk-import-link--green" onClick={onClick}>Download Latest Feature Records</div>
            )
        ) : (
            <div className="bulk-import-link--gray" onClick={onClick}>No Feature Records to Download</div>
        )}
      </div>);
};

export const DropZone = ({parent}) => {
    return (
        <Fragment>
            {_dropZone(parent, (
              <Fragment>
                <div className="bulk-import-fileUpload-image"></div>
                <div className="bulk-import-fileUpload-text">
                    <p>Drag and Drop Files</p>
                    <p>Supported File Formats: CSV Only</p>
                </div>
                <span className="bulk-import-fileUpload-subtext">+ Select files from Browser</span>
              </Fragment>
            ))}
            {_clearCheckbox(parent)}
            {_assignRelatedBoxes(parent)}
            {_createCopies(parent)}

        </Fragment>
    )
}

export const Uploading = () => {
    return (
        <div className="bulk-import-fileUpload">
            <div className="bulk-import-fileUpload-image--loader"></div>
            <div className="bulk-import-fileUpload-image--loader-text">
                <p>Please Wait...</p>
                <p>Reading &amp; Parsing Document</p>
            </div>
        </div>
    );
}

export const FixDropZone = ({parent, csv}) => {
    const { validationData } = parent.state;
    const errorCount = (validationData && validationData.errors && Object.keys(validationData.errors).length) || 0;
    const getErrorLog = () => {
        _.map(validationData.errors, err => {
            return (
                <li></li>
            );
        });
    };
    return (
        <Fragment>
            {_dropZone(parent, (
                <Fragment>
                    <div className="bulk-import-fileUpload-review">
                        <ul>
                            <li>
                                Total Products <span>{csv.length}</span>
                            </li>
                            <li>
                                Products Ready for Import <span>{csv.length - errorCount}</span>
                            </li>
                            <li>
                                Product Errors <span>{errorCount}</span>
                            </li>
                        </ul>
                        {errorCount > 0 ? (
                            <div className="bulk-import-fileUpload-review--error">
                                Error Log
                                <ul className="bulk-import-fileUpload-review--errors">
                                    {getErrorLog()}
                                </ul>
                            </div>
                        ) : (
                            <div className="bulk-import-fileUpload-review--success">
                                Success!
                            </div>
                        )}
                    </div>
                    <div className="bulk-import-fileUpload-undertext">Drag &amp; Drop To Upload New File</div>
                    <span className="bulk-import-fileUpload-subtext">+ Select files from Browser</span>
                </Fragment>
            ))}
            {_clearCheckbox(parent)}
            {_assignRelatedBoxes(parent)}
            {_createCopies(parent)}
        </Fragment>
    )
}

